import { SocialLocationPostCallToActionType } from "./SocialLocationPostCallToActionType.js";

export function showCallToActionUrl(values) {
  return values.callToAction &&
    values.callToAction.actionType !==
    SocialLocationPostCallToActionType.CALL &&
    values.callToAction.actionType !==
    SocialLocationPostCallToActionType.ACTION_TYPE_UNSPECIFIED;
}
